import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { TipusTiquets } from '../../models/tipus-tiquets.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { TipusTiquetsService } from '../../services/tipus-tiquets.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';

@Component({
  selector: 'app-tipus-tiquets-editor',
  templateUrl: './tipus-tiquets-editor.component.html',
  styleUrls: ['./tipus-tiquets-editor.component.scss']
})
export class TipusTiquetsEditorComponent implements OnInit {

  secure_id: string;
  tipusTiquets: TipusTiquets;
  dialogData: ComponentDialog;
  closeButtonText: string;

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(
    private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private tipusTiquetsService: TipusTiquetsService,
    private i18n: I18n,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    public thisDialogRef: MatDialogRef<TipusTiquetsEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.tipusTiquets = Builder.newTipusTiquets();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
   }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.tipusTiquetsService.getTipusTiquet(this.secure_id).subscribe(data => {
        this.tipusTiquets = data;
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.tipusTiquetsService.setTipusTiquet(this.tipusTiquets).subscribe(result => {
        this.toastr.info(this.i18n('Tipus de tiquet guardat correctament'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol esborrar el tipus de tiquet?'))
    .then((confirmed) => {
        if (confirmed) {
          this.tipusTiquetsService.removeTipusTiquet(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Tipus de tiquet esborrat correctament'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }


}
